import React, {Component} from 'react';
import Slider from 'react-slick';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {
    login,
    resendConfirmationEmail
} from '../../actions/Index';
import {renderPasswordInputField, renderEmailInputField} from '../Layout/FormInputs'
import {toastr} from 'react-redux-toastr';
import {langs} from '../../config/localization';
import Modal from '../Elements/Modal';
import {updateUserDetailsLocalStorage} from "../../actions/Common";
import {Loader} from "../Common/Loader";
import About from "../Common/About";
import {focusOnError} from "../../utils";
class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            toggleModal     : false,
            modalType       : '',
            username        : '',
            accessToken     : '',
            tokenType       : '',
            showLoader      : false
        };
    }



    /**
     * Resend confirmation email
     */
    resendConfirmationEmail() {
        let values = {};

        if(this.state.username != '') {
            values = {username: this.state.username};
        } else if(this.state.accessToken != '') {
            values = {
                access_token: this.state.accessToken,
                tokenType   : this.state.tokenType
            };
        }

        //Call the resend confirm email action
        this.props.resendConfirmationEmail(values, (response)=>{
            if(response.status === 200){
                this.setState({toggleModal : false});
                toastr.success(langs.success, langs.messages.confirmation_email_sent_success);
            }else {
                toastr.error(langs.error, langs.messages.default_error);
            }
        });
    }

    /**
     * Close modal
     */
    closeModal() {
        this.setState({toggleModal : false});
    }

    /**
     * Render the login form
     * @returns {*}
     */
    render(){
        const {handleSubmit} = this.props;
        const TopSliderSettings = {
            arrows: true,
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe:false,
            autoplay: false,
            responsive: [
                {
                breakpoint: 768,
                settings: {
                    arrows: true,
                }
            },

        ]
        };
        if(!this.state.showLoader) {
            return (
                <div>
                <section className="landing-page">
                        <div>
                            <div className="landing-banner" style={{backgroundImage:'url(/assets/images/eathdeck/film_01.png)'}} >
                                <h2><a href="/user-guide">What's in your bottle? </a></h2>
                            </div>
                        </div>
                </section>
                <About />
                </div>
            );
        } else {
            return <Loader/>
        }
    }
}

/**
 * Form validations
 * @param values
 * @returns {{}}
 */
function validate(values){
    let errors = {};

    if(!values.username){
        errors.username = langs.validation_messages.email_username_required;
    }

    if(!values.password){
        errors.password = langs.validation_messages.password_required;
    }

    if(values.password && values.password.length > 32){
        errors.password = langs.validation_messages.password_length;
    }

    return errors;
}

export default reduxForm({
    validate,
    form: 'Login',
    onSubmitFail: (errors) => {
        focusOnError(errors)
    }
})(
    connect(null, {login, resendConfirmationEmail})(Home)
);



// WEBPACK FOOTER //
// ./components/Home/Home.js